// ترجمه‌ی نشانه‌ی زمانِ تقریبی به زبانِ **بیننده**.
//
// جدا از `approxTime.ts` است: اون فایل فقط رشته رو **می‌فهمه** (parse) و به
// هیچ زبانی کار نداره؛ این یکی نتیجه‌ش رو به زبانِ کاربر درمی‌آره. تفکیک باعث
// می‌شه منطقِ خوندن بدونِ i18n هم قابل تست بمونه.
//
// از فاز ۴ اینجاست، نه در اپ موبایل: سایت هم دقیقاً همین برچسب‌ها رو نشون
// می‌ده و دو تا پیاده‌سازی یعنی روزی که یکی‌شون عوض شه، اون‌یکی جا می‌مونه.
import { days, t } from './i18n.ts';
import { parseApprox } from './approxTime.ts';

export function formatApprox(label?: string | null): string {
  const a = parseApprox(label);
  if (a.kind === 'preset') return t(a.key);
  if (a.kind === 'around') return t('aroundTime', { day: days()[a.dow], hour: a.hour });
  return a.text;
}
